var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90847 1.71556C8.826 0.0843969 11.1745 0.084396 12.092 1.71556L18.7884 13.6202C19.6883 15.2201 18.5322 17.1968 16.6966 17.1968H3.30388C1.4683 17.1968 0.312188 15.2201 1.2121 13.6202L7.90847 1.71556ZM11.2001 13.597C11.2001 14.2597 10.6629 14.797 10.0001 14.797C9.3374 14.797 8.80015 14.2597 8.80015 13.597C8.80015 12.9342 9.3374 12.397 10.0001 12.397C10.6629 12.397 11.2001 12.9342 11.2001 13.597ZM10.0001 3.99697C9.3374 3.99697 8.80015 4.53423 8.80015 5.19697V8.79697C8.80015 9.45971 9.3374 9.99697 10.0001 9.99697C10.6629 9.99697 11.2001 9.45971 11.2001 8.79697V5.19697C11.2001 4.53423 10.6629 3.99697 10.0001 3.99697Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeWarningIcon);
export default __webpack_public_path__ + "static/media/NoticeWarningIcon.d4d2f8c6c08953491f936cc0c7012e46.svg";
export { ForwardRef as ReactComponent };